import tw from 'tailwind-styled-components';
import styled from 'styled-components';

export const Container = tw.div`
pt-3
pb-3.5	
flex
flex-col
`;

export const StyledContainer = styled(Container)`
  border-radius: 10px;
  border: 1px solid #bbc4ba;
  width: 12.5rem;
  background: #fff;
`;

export const IconWrapper = tw.div`
    w-7
    h-7
    mr-4
`;

export const StyledIconWrapper = styled(IconWrapper)`
  padding: 5px;
`;

export const SingleItem = tw.div`
    flex
    flex-row
    items-center
    cursor-pointer
`;

export const StyledSingleItem = styled(SingleItem)`
  padding: 0.75rem 0rem 0.75rem 1.1875rem;
  margin: 0 auto;
  :hover {
    background: #e6e7ed;
  }
`;

export const TWImg = tw.img`
w-full
`;

export const ShareIconHolder = styled.div`
  padding-bottom: 6px;
  display: flex;
  width: 200px;
  flex-direction: row-reverse;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
export const Icon = tw.div`
inline-block
cursor-pointer
`;
export const IconTemp = tw.div`
inline-block`;
